import "core-js/modules/es.array.concat.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  id: "materialSubmit"
};
var _hoisted_2 = {
  "class": "common-card-body"
};
var _hoisted_3 = {
  key: 0,
  "class": "type-choose"
};
var _hoisted_4 = {
  "class": "submit-explain"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = {
  key: 1
};
var _hoisted_7 = {
  key: 2
};
var _hoisted_8 = {
  "class": "choose-form flex-align ant-round-form"
};
var _hoisted_9 = {
  "class": "flex-align",
  style: {
    "width": "500px"
  }
};
var _hoisted_10 = {
  "class": "part-label"
};
var _hoisted_11 = {
  "class": "part-label",
  style: {
    "margin-right": "32px"
  }
};
var _hoisted_12 = {
  key: 1,
  "class": "material-display"
};
var _hoisted_13 = {
  "class": "material-info"
};
var _hoisted_14 = {
  "class": "info-area flex-align",
  style: {
    "padding-left": "0"
  }
};
var _hoisted_15 = {
  "class": "info-area flex-align"
};
var _hoisted_16 = {
  "class": "info-area flex-align",
  style: {
    "padding-right": "0"
  }
};
var _hoisted_17 = {
  "class": "info-area flex-align",
  style: {
    "padding-left": "0"
  }
};
var _hoisted_18 = {
  "class": "info-area flex-align"
};
var _hoisted_19 = {
  "class": "submit-explain",
  style: {
    "margin-top": "8px"
  }
};
var _hoisted_20 = {
  "class": "material-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_header_nav = _resolveComponent("header-nav");
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_select_option = _resolveComponent("a-select-option");
  var _component_a_select = _resolveComponent("a-select");
  var _component_a_button = _resolveComponent("a-button");
  var _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_header_nav, {
    content: "".concat(_ctx.$t('pages_router_003'), " / ").concat(_ctx.$t('pages_router_009'))
  }, null, 8, ["content"]), _createElementVNode("div", _hoisted_2, [_ctx.isAdvance || _ctx.isUpdate ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_ctx.isAdvance ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("pages_receive_079")), 1)) : _createCommentVNode("", true), _ctx.isAdvance ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("pages_receive_080")), 1)) : _createCommentVNode("", true), _ctx.isUpdate ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('pages_receive_117')), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_a_col, {
    span: 10
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("pages_receive_003")) + ": ", 1)];
    }),
    _: 1
  }), _createVNode(_component_a_select, {
    value: _ctx.vaId,
    "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.vaId = $event;
    }),
    "show-search": "",
    "option-label-prop": "label",
    "option-filter-prop": "label",
    disabled: _ctx.isUpdate,
    onChange: $setup.vaChange
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vaList, function (va) {
        return _openBlock(), _createBlock(_component_a_select_option, {
          key: va.id,
          value: va.id,
          label: "".concat(va.simpleName ? va.simpleName + '-' : va.simpleName).concat(va.currency ? va.currency + '-' : va.currency).concat(va.accountNo)
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(_toDisplayString(va.simpleName ? va.simpleName + "-" : va.simpleName) + _toDisplayString(va.currency ? va.currency + "-" : va.currency) + _toDisplayString(va.accountNo), 1)];
          }),
          _: 2
        }, 1032, ["value", "label"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["value", "disabled", "onChange"])]), _createElementVNode("div", {
    style: _normalizeStyle({
      visibility: _ctx.transTypeText ? 'visible' : 'hidden'
    }),
    "class": "part flex-align"
  }, [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("pages_receive_081")) + ": ", 1), _createVNode(_component_a_button, {
    type: "round",
    style: {
      "font-weight": "600",
      "min-width": "150px"
    }
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.transTypeText), 1)];
    }),
    _: 1
  })], 4)])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('pages_receive_067')) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.materialInfo.payerName), 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('pages_receive_013')) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.materialInfo.transTypeText), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('pages_router_004')) + " :", 1), _createElementVNode("span", null, _toDisplayString(_ctx.materialInfo.receiveAccount), 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('pages_receive_070')) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.materialInfo.receiveAmtText), 1)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('pages_receive_115')) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.materialInfo.fillAmtText), 1)])]), _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("pages_receive_116")), 1)])), _createElementVNode("div", _hoisted_20, [_createVNode(_component_router_view)])])]);
}